/* eslint-disable */
import { Button } from '../../Components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '../../Components/ui/popover'
import { addNumberSuffix, monthShortNames } from '../../utils/Util'
import { isDematUser } from '../../utils/AuthUtil'
import OrderOtpVerification from '../FirstIdeas/OrderOtpVerification'

const ActionPlanBottomBar = ({
  flowStep,
  sipDate,
  sipDates,
  selectedDay,
  setSelectedDay,
  disableButtons,
  generateOTP,
  loading,
  setMessageModalState,
  openOTPPopup,
  setOpenOTPPopup,
  userDetails,
  email,
  handleSipOrOT,
}) => {
  return (
    <div className='fabits-bottom-sheet fixed bottom-0 left-0 right-0 z-10 mx-auto mt-2 p-4 lg:max-w-[1128px]'>
      <div className='mx-auto space-y-2'>
        {flowStep === 0 && (
          <div className='mt-4'>
            <Popover>
              <PopoverTrigger asChild>
                <Button
                  variant={'outline'}
                  className='mx-auto flex h-auto min-h-12 w-full justify-start rounded-lg border-black-200 bg-white px-4 py-3 text-left font-normal hover:bg-black-50'
                >
                  <span className='flex items-center gap-x-2 text-black-700'>
                    <p>
                      SIP starts on -{' '}
                      <b>
                        {addNumberSuffix(sipDate.split('/')[0])}{' '}
                        {monthShortNames[parseInt(sipDate.split('/')[1], 10) - 1]}{' '}
                        {sipDate.split('/')[2]}
                      </b>
                    </p>
                  </span>
                </Button>
              </PopoverTrigger>
              <PopoverContent
                className='w-auto rounded-full border-black-200 bg-white p-0 shadow-[0_12px_28px_rgba(4,3,19,0.14)]'
                align='center'
                side='top'
              >
                <div className='flex gap-x-2 p-2'>
                  {sipDates.map((day, index) => (
                    <Button
                      key={(day + index).toString()}
                      className={`inline-block h-8 w-8 rounded-full p-0 ${
                        selectedDay !== +day
                          ? 'border border-black-200 bg-white text-black-600 hover:bg-black-50'
                          : 'bg-primary-600 text-white'
                      }`}
                      size='simple'
                      onClick={() => setSelectedDay(+day)}
                    >
                      {day}
                    </Button>
                  ))}
                </div>
              </PopoverContent>
            </Popover>
          </div>
        )}

        {isDematUser() ? (
          <Button
            disabled={disableButtons <= 0}
            className='w-full bg-primary-600 disabled:bg-primary-300'
            onClick={generateOTP}
            loading={loading}
          >
            Continue
          </Button>
        ) : (
          <Button
            disabled={disableButtons <= 0}
            className='w-full bg-primary-600 disabled:bg-primary-300'
            onClick={() =>
              setMessageModalState({
                message: 'Your KYC is incomplete.',
                linkMessage:
                  'Click here to complete your KYC and to enable hassle free, one-click investing.',
                severity: 'info',
              })
            }
          >
            Complete your KYC
          </Button>
        )}

        {flowStep === 0 && (
          <p className='mt-2 text-center text-xs font-semibold text-black-500'>
            Keep your internet banking password ready for quick setup.
          </p>
        )}

        {openOTPPopup && (
          <OrderOtpVerification
            phoneNumber={userDetails?.phoneNumber}
            openOTPPopup={openOTPPopup}
            setOpenOTPPopup={setOpenOTPPopup}
            email={email}
            handleSipOrOT={handleSipOrOT}
          />
        )}
      </div>
    </div>
  )
}

export default ActionPlanBottomBar
